export default __webpack_public_path__ + "static/media/dashbordIcon.193d04a1.svg";